import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAppBar,{staticClass:"rounded-xl mb-5 text-center",attrs:{"color":"primary","rounded":""}},[_c(VImg,{attrs:{"max-width":_vm.logoWidth,"src":require("@/../public/static/logo_white.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }